import React from 'react'
import { Button } from 'reactstrap'
import { FAIcon } from './FAIcon'
import styles from './CircleButton.less'
import { pt } from 'common-data/proptypehelpers'
import Tooltip from 'rc-tooltip'

export class CircleButton extends React.Component {
  static propTypes = {
    icon: pt.string,
    children: pt.any,
    size: pt.string,
    placement: pt.string,
    toolTip: pt.string,
    loading: pt.bool,
    readonly: pt.bool
  }

  static defaultProps = {
    icon: 'check',
    size: '',
    loading: false,
    readonly: false
  }

  render () {
    const { icon, children, size, toolTip, placement, loading, readonly, ...rest } = this.props

    const button = <Button disabled={loading || readonly} {...rest} className={styles[`btn${size}`]}><i className={`fad fa-${icon}`} style={{ color: '#ffffff' }} /></Button>

    const { color } = rest
    const overlayStyle = color || ''

    if (toolTip) {
      return (
        <Tooltip placement={placement} overlayClassName={overlayStyle} overlay={<span dangerouslySetInnerHTML={{ __html: toolTip }}></span>}>
          {button}
        </Tooltip>
      )
    } else {
      return button
    }
  }
}
